import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

import { ReactComponent as DatetimeSvg } from "@/svgs/datetime.svg?react";

export default function DatetimeIcon(props: SvgIconProps) {
	return <SvgIcon {...props} component={DatetimeSvg} inheritViewBox />;
}
